import {
  User 
} from "lucide-react"

const AccountChip = () => {
  return (
    <User />
  )
}

export default AccountChip
